import { BaseModel } from './base-model';
import { SessionType } from './session-enums';
import {
  CustomDomain,
  TrackingSource,
  LinkCustomerMatchMethod,
  LinkCustomerMatchMethodLabels,
} from './campaign';
import { OfferIntents, SubscriptionOfferIntents, FunnelInputTypeEnum, FunnelInputTypeLabels } from './funnel';
import { TicketSystem, TicketSystemIDVariables } from './email-template';
import { createBaseUrl } from '../_helpers/functions';

export interface DeploymentLink extends BaseModel {
  name: string;
  campaign: number;
  step_key: string;
  step_type: FunnelInputTypeEnum;
  domain: number | CustomDomain;
  tracking_source: TrackingSource | number;
  sid1: string | null;
  sid2: string | null;
  sid3: string | null;
  link_type: SessionType;
  link_url?: string;
  updated?: string;
  language?: string;
  base_url?: string;
  is_first_step: boolean;
  shopify_public_plugin: string | number;
  is_action: boolean;
  match_method: LinkCustomerMatchMethod;
  offer_intent: OfferIntents;
  include_ticket_id?: boolean;
  session_type: SessionType;
}

export interface SmartlinkPreviewData {
  email?: string;
  customer_id?: string;
  phone?: string;
  order_id?: string;
  order_number?: string;
  product_id?: string;
  campaign_product_id?: string;
  variant_id?: string;
  token?: string;
  url?: string;
  subscription_id?: string;
}

export function getLinkTargetPath(link: DeploymentLink) {
  let path = '';

  if (link.step_type) {
    path = FunnelInputTypeLabels[+link.step_type];
  } else if (link.step_key) {
    path = link.step_key.split('-').join(' ');
  }

  return path;
}

export function appendPreviewQueryParams(url: string, previewData: SmartlinkPreviewData): string {
  const params = [];
  const fields = ['order_number', 'order_id', 'product_id', 'campaign_product_id', 'variant_id', 'subscription_id'];

  fields.forEach(field => {
    if (previewData[field]) {
      params.push(field + '=' + encodeURIComponent(previewData[field]));
    }
  });

  if (params.length === 0) {
    return url;
  }
  const separator = url.indexOf('?') >= 0 ? '&' : '?';
  return url + separator + params.join('&');
}

export function buildDeploymentLinkUrl(
  link: DeploymentLink,
  activeDomain: string,
  ticketSystem: TicketSystem,
  previewData: SmartlinkPreviewData = null
) {
  let domainStr = '';
  if (link.domain && link.domain['domain']) {
    domainStr = link.domain['domain'];
  } else {
    domainStr = activeDomain;
  }

  console.log(link);
  console.log(previewData);
  let url = createBaseUrl(domainStr);
  let separator = '?';
  let checkFirstStep = false;

  if (link.step_type) {
    url += separator + 'step_type=' + link.step_type.toString();
    separator = '&';
    checkFirstStep = true;
  } else if (link.step_key && link.step_key.length) {
    url += 'start/' + encodeURIComponent(link.step_key);
    checkFirstStep = true;
  }

  if (checkFirstStep && link.is_first_step) {
    url += separator + 'is_first_step=true';
    separator = '&';
  }

  if (link.session_type) {
    url += separator + 'session_type=' + link.session_type.toString();
    separator = '&';
  }

  let trackingSourceId = null;
  if (link.tracking_source) {
    if (link.tracking_source['id']) {
      trackingSourceId = link.tracking_source['id'];
    } else {
      trackingSourceId = link.tracking_source;
    }
  }

  if (trackingSourceId) {
    url += separator + 'tracking_source=' + trackingSourceId.toString();
    separator = '&';
  }

  if (link.include_ticket_id && ticketSystem && ticketSystem.type) {
    url += separator + 'ticket_id=' + TicketSystemIDVariables[ticketSystem.type];
    separator = '&';
  }

  ['sid1', 'sid2', 'sid3', 'language'].forEach((key: string) => {
    let value: string = link[key];
    if (value && value.length) {
      value = value.trim();
      if (value.length) {
        url += separator + key + '=' + encodeURIComponent(value.trim().toLowerCase());
        separator = '&';
      }
    }
  });

  if (link.match_method) {
    const field = LinkCustomerMatchMethodLabels[+link.match_method].replace(' ', '_').toLowerCase();
    url += separator + field + '=' + (previewData ? previewData[field] || '' : '{}');
    separator = '&';
  }

  if (previewData) {
    if (link.offer_intent) {
      url += '&offer_intent=' + link.offer_intent;
    }
    url = appendPreviewQueryParams(url, previewData);
  } else {
    if (link.is_action) {
      if (link.offer_intent) {
        if (SubscriptionOfferIntents.indexOf(link.offer_intent) === -1) {
          url += separator + 'order_number={}&product_id={}&variant_id={}';
        } else {
          url += separator + 'subscription_id={}';
        }
        url += '&offer_intent=' + link.offer_intent;
      } else {
        url += separator + 'order_number={}&product_id={}&variant_id={}';
      }
      separator = '&';
    }
  }

  return url;
}
